export default {
  'ICBC': '0101',
  'ABC': '0102',
  'CCB': '0104',
  'BOC': '0103',
  'BCOM': '0108',
  'CIB': '0116',
  'CITIC': '0109',
  'CEB': '0110',
  'PAB': '0198',
  'PSBC': '0128',
  'SPDB': '0117',
  'CMBC': '0112',
  'CMB': '0115',
  'GDB': '0113',
  'HXB': '0111'
}



// WEBPACK FOOTER //
// ./src/data/bankCodes.js